module.exports = __webpack_public_path__ + "media/images/bus/conditions/MSYS-44c1b61d964d779561062acbf952a48c.svg";